// extracted by mini-css-extract-plugin
export default {"details":"_1Hw2a99XTd5z8FpFSvkUq5","details__info-panel":"_4kBV2LldCDdK4N8UfuQShq","details__spec-container":"WgXBDGq3jH28SglR0c1mN"};